// Import the mixins
import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'

// Import firebase
import { propertiesModel } from '@/firebase/firebase-config'

export const BindToLeases = {

    /*
	**  Register the mixins
	*/

	mixins: [

        BugsnagService

    ],

    /*
	**  Set up the data
	*/

	data: () => ({

        leases: null

    }),

    /*
	**  Methods
    */
    
    methods: {

        bindToLeasesHandler: function(property_id, resident_id) {

            try {

                this.$bind('leases', propertiesModel.doc(property_id).collection('leases').where('relationships.resident', '==', resident_id).where('meta.deleted_at', '==', null))
                .catch(error => {

                    /*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */
                
                    this.reportAuthBugsnagError({
                        title: 'Bind to the Leases from Firestore',
                        errorType: 'Firestore Database',
                        section: 'Events/Leases',
                        uid: 'Tw0kMZAwStPTMrtflM8Z',
                        error: error
                    });

                });

            } catch (e) {

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */
            
                this.reportAuthBugsnagError({
                    title: 'Unable to Perform the Query to Bind to the Lease Documents from Firestore',
                    errorType: 'Firestore Database',
                    section: 'Events/Leases',
                    uid: 'WOqv0kW6D6ORIlxwkECu',
                    error: e
                });

            }

        }

    }

}